import React from 'react';
import {
    getMonthlyCases,
    getMonthlyChangeRequests,
    getMonthlyCompanies,
    getMonthlyMessages,
    getMonthlyOrders,
    getMonthlyProjects,
    getMonthlyUnits,
    getMonthlyUsers,
} from '@/services/overTimeStatistics';
import { useAsyncStateWithIsLoading } from '@/utils/hooks';
import OverTimeCard from './OverTimeCard';
import theme from './OverTimeStatisticsPage.module.scss';

const OverTimeStatisticsPage: React.FC = () => {
    const [users, , , usersLoading]       = useAsyncStateWithIsLoading(() => getMonthlyUsers(), [], null);
    const [companies, , , coLoading]      = useAsyncStateWithIsLoading(() => getMonthlyCompanies(), [], null);
    const [units, , , unitsLoading]       = useAsyncStateWithIsLoading(() => getMonthlyUnits(), [], null);
    const [projects, , , projLoading]     = useAsyncStateWithIsLoading(() => getMonthlyProjects(), [], null);
    const [messages, , , msgLoading]      = useAsyncStateWithIsLoading(() => getMonthlyMessages(), [], null);
    const [crs, , , crLoading]            = useAsyncStateWithIsLoading(() => getMonthlyChangeRequests(), [], null);
    const [orders, , , ordLoading]        = useAsyncStateWithIsLoading(() => getMonthlyOrders(), [], null);
    const [cases, , , casesLoading]       = useAsyncStateWithIsLoading(() => getMonthlyCases(), [], null);

    return (
        <div className={theme.pageGrid}>
            <OverTimeCard
                cardId="users"
                title="Users over time"
                data={users}
                loading={usersLoading}
                series={[
                    { dataKey: 'developerCount',  name: 'Developers',  color: '#4f81bd' },
                    { dataKey: 'contractorCount', name: 'Contractors', color: '#c0504d' },
                    { dataKey: 'buyerCount',      name: 'Buyers',      color: '#9bbb59' },
                    { dataKey: 'totalCount',      name: 'Total',       color: '#8064a2' },
                ]}
            />
            <OverTimeCard
                cardId="companies"
                title="Companies over time"
                data={companies}
                loading={coLoading}
                series={[
                    { dataKey: 'developerCount',  name: 'Developers',  color: '#4f81bd' },
                    { dataKey: 'contractorCount', name: 'Contractors', color: '#c0504d' },
                ]}
            />
            <OverTimeCard
                cardId="units"
                title="Units over time"
                data={units}
                loading={unitsLoading}
                series={[
                    { dataKey: 'unitCount', name: 'Units', color: '#4bacc6' },
                ]}
            />
            <OverTimeCard
                cardId="projects"
                title="Projects over time"
                data={projects}
                loading={projLoading}
                series={[
                    { dataKey: 'projectCount', name: 'Projects', color: '#f79646' },
                ]}
            />
            <OverTimeCard
                cardId="messages"
                title="Messages over time"
                data={messages}
                loading={msgLoading}
                series={[
                    { dataKey: 'threadCount',  name: 'Threads',  color: '#4bacc6' },
                    { dataKey: 'messageCount', name: 'Messages', color: '#8064a2' },
                ]}
            />
            <OverTimeCard
                cardId="change-requests"
                title="Change requests over time"
                data={crs}
                loading={crLoading}
                series={[
                    { dataKey: 'approvedCount', name: 'Approved', color: '#9bbb59' },
                ]}
            />
            <OverTimeCard
                cardId="orders"
                title="Orders over time"
                data={orders}
                loading={ordLoading}
                series={[
                    { dataKey: 'orderCount', name: 'Orders', color: '#f79646' },
                ]}
            />
            <OverTimeCard
                cardId="cases"
                title="Cases over time"
                data={cases}
                loading={casesLoading}
                series={[
                    { dataKey: 'caseCount', name: 'Cases', color: '#c0504d' },
                ]}
            />
        </div>
    );
};

export default OverTimeStatisticsPage;
